//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IM from '@/data/im'
import { Dialog } from 'vant'

const DELETE_BTN_WITTH = 138
const SHOW_DELETE_BTN_WIDTH = DELETE_BTN_WITTH / 2
export default {
    props: {
        chat: {
            type: Object
        },
        is_consultant_user: Boolean,
        move_cancel: Boolean,
        index: Number
    },
    watch: {
        move_cancel (latest) {
            if (latest) {
                this.move_starting = false
                this.start_x = 0
                this.start_y = 0
                this.show_del = false
            }
        }
    },
    data () {
        return {
            move_starting: false,
            start_x: 0,
            start_y: 0,
            show_del: false
        }
    },
    methods: {
        goChat (e) {
            const { id } = e.currentTarget.dataset
            const url = `/chat_list/chat?session_id=${id}`
            IM.resetChatMapByConversation()
            IM.readChat(id)
            wx.navigateTo({
                url
            })
        },
        async setTop() {
            const params = {
                topped: !this.chat.topped
            }
            await IM.setChatTop(this.chat.id, params)
            this.show_del = false
        },
        delChat () {
            Dialog.confirm({
                title: '提示',
                message: '确定要删除',
            }).then(() => {
                IM.delChat(this.chat.id)
            }).catch(() => {
                this.show_del = false
            })
        },
        touchstart (e) {
            this.move_starting = true
            const { pageX, pageY } = e.touches[0]
            this.start_x = pageX
            this.start_y = pageY
            console.error(pageX, pageY)
        },
        touchmove (e) {
            const { pageX, pageY } = e.touches[0]
            const left = pageX - this.start_x
            const top = pageY - this.start_y
            if (
                Math.abs(left) > Math.abs(top) // check move angle
                &&
                Math.abs(left) >= SHOW_DELETE_BTN_WIDTH
            ) {
                this.$emit('disableScroll', this.index)
                this.show_del = left < 0
            }
        },
        touchend (e) {
            this.move_starting = false
            this.$emit('enableScroll')
        }
    }
}
